var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NewsList"},[_c('div',{staticClass:"banner"},[_c('Head')],1),_c('div',{staticClass:"conent"},[_c('List')],1),_c('Floor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }